import { axiosEduServer } from "../utils/configAxios";

export const crearEleccionIdioma = (data) => {
  return axiosEduServer.post('/eleccionidioma', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarEleccionIdioma = (id, data) => {
  return axiosEduServer.put(`/eleccionidioma/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarEleccionIdioma = (id) => {
  return axiosEduServer.delete(`/eleccionidioma/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOneEleccionIdioma = (id) => {
  return axiosEduServer.get(`/eleccionidioma/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllEleccionIdiomas = () => {
  return axiosEduServer.get('/eleccionidioma').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};
